'use client'
import Image from "next/image";
import Logo from "../../assets/images/header/seekintro-logo.svg";
import mobileLogo from "../../assets/images/header/mobileLogo.svg";
import classes from "./Navbar.module.scss";
import {useAppContext} from "@/app/context/UserContext";
import {useTranslation} from "react-i18next";
import Link from "@/app/components/providers/proxyProvider/Link";
import {useEffect, useMemo, useRef, useState} from "react";
import {Dropdown, notification, Spin} from "antd";
import RoundedButton from "@/app/components/buttons/rounded-button/RoundedButton";
import DropdownItems from "@/app/data/dropdownItems";
import {LoadingOutlined} from "@ant-design/icons";
import {addRole} from "@/app/actions/roleActions";
import {switchRole} from "@/app/actions/roleActions";
import {pusherClient} from "@/app/lib/pusher";
import useModal from "@/app/hooks/useModal";
import MeetingForm from "@/app/[locale]/(main)/calendar/meeting-form/MeetingForm";
import {fetchUnreadNotifications} from "@/app/actions/calendarActions";
import moment from "moment";
//import {fetchMeetingNotifications} from "@/app/actions/calendarActions";

const Navbar = () => {
    const [open, setOpen] = useState(false);
    const {t} = useTranslation();
    const {
        user, isSeeker, isMediator, loading, getUser, notifications, setNotifications, meetingNotificationsNumber,
        setMeetingNotificationsNumber
    } = useAppContext();
    const {openModal, closeModal, ModalComponent} = useModal();
    const dropdownRef = useRef(null);
    const [api, contextHolder] = notification.useNotification();
    const isSeekerMediator = useMemo(() => user?.roles?.some(role => role.name === 'Mediator') && user?.roles?.some(role => role.name === 'Seeker'), [user]);
    const [loadingSwitch, setLoadingSwitch] = useState(null);
    const channelRef = useRef(null);
    const notificationChannelRef = useRef(null);
    const [unreadNotifications, setUnreadNotifications] = useState([]);


    const openNotification = (type, placement, text) => {
        api[type]({
            message: `${type === 'error' ? t('notifications.error') : t('notifications.success')}`,
            description: text,
            placement,
        });
    };

    const {items, profileItems, selectedValue} = DropdownItems(openNotification, notifications);
    const filteredMenuItems = items.filter(item => item.key !== selectedValue.key);

    useEffect(() => {
        // Function to handle click outside dropdown
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutside);

        //fetchMeetingNotifications()

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    useEffect(() => {
        if (user) {
            if (!channelRef.current) {
                channelRef.current = pusherClient.subscribe(`private-chat-${user.id}`);
            }
            channelRef.current.bind('MessageSent', function (data) {
                setNotifications((prev) => prev + 1)
            });
            channelRef.current.bind('MessageDeleted', function (data) {
                setNotifications((prev) => prev - 1);
            });
            if (!notificationChannelRef.current) {
                notificationChannelRef.current = pusherClient.subscribe(`private-notifications-${user.id}`);
            }

            notificationChannelRef.current.bind('NewMeetingInvite', function (data) {
                setMeetingNotificationsNumber((prev => prev + 1))
            });
            // open modal if there is unread ending meet notifications

            let scheduledData = [];
            fetchUnreadNotifications().then((res) => {
                scheduledData = res.map(item => {
                    const {data} = item;
                    if (data.status === 'ENDED') {
                        return {
                            ...data,
                            seeker: `${data.seeker.email} (${data.seeker.name})`,
                            start: moment(data.timeRange[0]).toDate(),
                            end: moment(data.timeRange[1]).toDate(),
                            guest: `${data.guest.name} (${data.guest.email})`
                        }
                    }

                    return null;
                }).filter(item => item !== null);
                setUnreadNotifications(scheduledData);
                scheduledData.forEach((notification, index) => {
                    openModal(index);
                });
            })

            notificationChannelRef.current.bind('MeetingEndedNotification', function (data) {
                scheduledData = [...scheduledData, {
                    ...data,
                    start: moment(data.timeRange[0]).toDate(),
                    end: moment(data.timeRange[1]).toDate(),
                    guest: `${data.guest.name} (${data.guest.email})`,
                    seeker: `${data.seeker.name} (${data.seeker.email})`
                }]

                setUnreadNotifications(scheduledData);
                scheduledData.forEach((notification, index) => {
                    openModal(index);
                });
            });

            return () => {
                channelRef.current.unbind();
                notificationChannelRef.current.unbind();
                pusherClient.unsubscribe(user.id)
            }
        }
    }, [user]);


    const handleRoleAdd = async () => {
        setLoadingSwitch(true);
        try {
            const result = await addRole();
            if (result) {
                getUser();
                openNotification('success', 'bottomRight', t('notifications.roleAddSuccess'));
            } else {
                openNotification('error', 'bottomRight', t('notifications.roleAddError'));
            }
        } finally {
            setLoadingSwitch(false);
        }
    };

    const handleRoleSwitch = async (roleId) => {
        setLoadingSwitch(roleId);
        try {
            const result = await switchRole(roleId);
            if (result) {
                getUser();
                openNotification('success', 'bottomRight', t('notifications.roleSwitchSuccess'));
            } else {
                openNotification('error', 'bottomRight', t('notifications.roleSwitchError'));
            }
        } finally {
            setLoadingSwitch(false);
        }
    };

    const notificationClass = notifications <= 9 ? classes.small : notifications <= 99 ? classes.medium : classes.large;

    return (<div className={classes.wrapper}>
        {contextHolder}
        <div className={classes.container}>
            <div className={classes.contentWrapper}>
                <Link href={'/'}>
                    <Image
                        src={Logo}
                        alt={"logo"}
                        className={classes.logo}
                    />

                    <Image
                        src={mobileLogo}
                        alt={"logo"}
                        className={classes.mobileLogo}
                    />
                </Link>
                <div className={classes.navMenu}>
                    <ul>
                        <li><Link href="/#about-section">{t("navbar.about")}</Link></li>
                        {/*<li>
                            <Dropdown overlayClassName={`${classes.dropdown} ${classes.currencyDropdown}`}
                                      menu={{items: filteredMenuItems}} trigger={['click']}>
                                <a onClick={(e) => e.preventDefault()}>
                                    <div className={classes.selectedCurrency}>
                                        <span>{selectedValue.value}</span>
                                        <Image src={arrowDown} alt={'arrow-down'}/>
                                    </div>
                                </a>
                            </Dropdown>
                        </li>*/}
                    </ul>
                    {user && <div className={classes.userInfoWrapper}>
                        {!isSeekerMediator && (<>
                            {isSeeker && !isMediator && (
                                <a className={classes.underline} onClick={() => handleRoleAdd(true)}>
                                    {loadingSwitch ? (<Spin size="small"/>) : (t('navbar.BecomeMediator'))}
                                </a>)}
                            {!isSeeker && isMediator && (
                                <a className={classes.underline} onClick={() => handleRoleAdd(false)}>
                                    {loadingSwitch ? (<Spin size="small"/>) : (t('navbar.BecomeSeeker'))}
                                </a>)}
                        </>)}
                        {isSeekerMediator && (<div className={classes.roleWrapper}>
                            {loadingSwitch === 2 ? (<div className={classes.spinnerContainer}>
                                <Spin size="small"/>
                            </div>) : (<span
                                className={`${classes.roleHeading} ${isMediator ? classes.selectedRole : ''}`}
                                onClick={() => handleRoleSwitch(2)}
                            >
                                        {t('role.mediator')}
                                    </span>)}
                            {loadingSwitch === 1 ? (<div className={classes.spinnerContainer}>
                                <Spin size="small"/>
                            </div>) : (<span
                                className={`${classes.roleHeading} ${isSeeker ? classes.selectedRole : ''}`}
                                onClick={() => handleRoleSwitch(1)}
                            >
                                         {t('role.seeker')}
                                    </span>)}
                        </div>)}
                        <Dropdown open={open} overlayClassName={`${classes.dropdown} ${classes.userDropdown}`}
                                  menu={{items: profileItems}} trigger={['click']}>
                            <a onClick={(e) => {
                                e.preventDefault();
                                setOpen(!open);
                            }}>
                                <div ref={dropdownRef} className={classes.userInfo}>
                                    <div className={`${classes.navIcon1} ${open && classes.open}`}>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                    <div className={classes.userIcon}>
                                        {user.profile_photo ?
                                            <Image className={classes.userImage} src={user.profile_photo}
                                                   alt={'user image'} width={20} height={20}/> : <span
                                                className={classes.imagePlaceholder}>{user.name ? user.name.charAt(0) : ''}</span>}
                                    </div>
                                    <span
                                        className={`${classes.allNotifications} ${notificationClass}`}>{(notifications + meetingNotificationsNumber) > 99 ? '99+' : notifications + meetingNotificationsNumber}</span>
                                </div>
                            </a>
                        </Dropdown>
                    </div>}
                </div>

                {!loading && !user && <Link className={classes.link} href={'/login'}><RoundedButton
                    className={classes.btn}
                    type="primary"
                >
                    {t('login')}
                </RoundedButton></Link>}
                {loading && !user && <Spin indicator={<LoadingOutlined style={{fontSize: 24, width: 110}} spin/>}/>}
            </div>
        </div>
        {unreadNotifications.length > 0 && isSeeker && unreadNotifications.map((notification, index) => (
            <div key={index}>
                <ModalComponent
                    id={index}
                >
                    <MeetingForm setUnreadNotifications={setUnreadNotifications} closeFirstModal={closeModal}
                                 selectedEvent={notification} verification={true}/>
                </ModalComponent>
            </div>))}
    </div>)
}

export default Navbar;